import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import type { OrderType } from '@klareospace/pharos-lib-types';
import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createOrderTypeApi, orderTypeKeys } from '../api';

export function useArchiveOrderType(): UseMutationResult<OrderType, Error, string> {
  const client = useApiClient('admin-auth');
  const api = createOrderTypeApi(client);
  const queryClient = useQueryClient();
  const { t } = useTranslation('settings');

  return useMutation<OrderType, Error, string>({
    mutationFn: (id: string) => api.archiveOrderType(id),
    ...createMutationCallbacks({
      errorKey: 'orderTypes.toast.archiveError',
      invalidateKeys: [orderTypeKeys.lists()],
      queryClient,
      successKey: 'orderTypes.toast.archived',
      t,
    }),
  });
}
